$(document).ready(function () {
  $('.form-group.radio_buttons').trigger('radio-group:init');
});

// INIT RADIO GROUP
$(document).on('radio-group:init', '.form-group.radio_buttons', function(e){
  var globalContainer = $(this),
      inputs = globalContainer.find('input[type="radio"]');

  inputs.each(function(){
      if(!$(this).parent('.radiobox').length){
          $(this).wrap('<div class="radiobox"></div>');
      }
  });

  checkInputsValue(globalContainer);
  inputs.change(function(){
      checkInputsValue(globalContainer);
  });
});

// FUNCTIONS
function checkInputsValue(globalContainer){
  var inputSelected = globalContainer.find('input[type="radio"]:checked');

  inputSelected.parent('.radiobox').addClass('checked');
  globalContainer.find('input[type="radio"]').not(inputSelected).parent('.radiobox').removeClass('checked');
}
